export class EquipmentManufacturer {
  manufacturerId: number;
  manufacturerName: string;
  categoryId: number;
  typeId: number;

  public static constructFromObjectJson(objectJson: any): EquipmentManufacturer {
    const equipmentManufacturer: EquipmentManufacturer = Object.assign(new EquipmentManufacturer(), objectJson);
    return equipmentManufacturer;
  }

  public static constructEquipmentManufacturer(manufacturerId: number, name: string ): EquipmentManufacturer {
    const equipmentManufacturer: EquipmentManufacturer = new EquipmentManufacturer();
    equipmentManufacturer.manufacturerId = manufacturerId;
    equipmentManufacturer.manufacturerName = name;
    return equipmentManufacturer;
  }
}
